import { createApp } from "vue";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "./api/http.js";
import jQuery from "jquery";
import VueCookies from "vue-cookies";
import moment from "moment";
import {initKuroshiroInstance} from './util/Kuroshiro'

// directive
import tooltip from "@/directive/tooltip";

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");
initKuroshiroInstance()

const app = createApp(App);
app.use(router).use(store);
// set secure, only https works
VueCookies.config("7d", "", "", true, "none");
app.config.globalProperties.$cookies = VueCookies;
app.config.globalProperties.$redirect = (page) => {
  router.push(page);
};
app.config.globalProperties.$filters = {
  formatDateTime(value) {
    return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
  },
};
app.directive("tooltip", tooltip);
app.mount("#app");
